import { render, staticRenderFns } from "./stopTable.vue?vue&type=template&id=55b60b34&scoped=true&"
import script from "./stopTable.vue?vue&type=script&lang=js&"
export * from "./stopTable.vue?vue&type=script&lang=js&"
import style0 from "./stopTable.vue?vue&type=style&index=0&id=55b60b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b60b34",
  null
  
)

export default component.exports